import { fetchSensitiveWordList } from '../services';

export default {
  namespace: 'SensitiveWordManage',
  state: {},
  effects: {
    * fetchSensitiveWordList ({ payload }, { call }) {
      const res = yield call(fetchSensitiveWordList, payload);
      return res;
    },
  },
  reducers: {
    update (state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
